import NextHead from "next/head";
interface Props {
  prefix: string;
  suffix?: string;
}
export function Head({
  prefix,
  suffix = " | Mission Control"
}: Props) {
  return <NextHead data-sentry-element="NextHead" data-sentry-component="Head" data-sentry-source-file="Head.tsx">
      <title>
        {prefix}
        {suffix}
      </title>
      <meta name="description" content={`${prefix}${suffix}`} data-sentry-element="meta" data-sentry-source-file="Head.tsx" />
    </NextHead>;
}